import { BrowserRouter, Route } from 'react-router-dom';
import { SentryRoutes } from '../libs/sentry';
import { Wizard } from './Wizard';

export default function Router() {
  return (
    <BrowserRouter>
      <SentryRoutes>
        <Route path="" element={<Wizard />} />
      </SentryRoutes>
    </BrowserRouter>
  );
}
